const FACEBOOK_APP_ID = process.env.FACEBOOK_APP_ID || 585647078748086
// const PERMISSION_SCOPE = process.env.PERMISSION_SCOPE || 'pages_read_engagement,instagram_manage_insights,pages_show_list,instagram_basic,public_profile' // 'public_profile,email,instagram_basic,pages_show_list,user_posts,read_insights'
const PERMISSION_SCOPE = process.env.PERMISSION_SCOPE || 'public_profile,email,instagram_basic,pages_show_list,instagram_manage_insights,pages_read_engagement'
const INSTAGRAM_AUTHORIZE_URL = process.env.INSTAGRAM_AUTHORIZE_URL || 'http://localhost:8081/api/v1/instagrams/authorize';
const INSTAGRAM_BASIC_AUTHORIZE_URL = process.env.INSTAGRAM_BASIC_AUTHORIZE_URL || 'http://localhost:8081/api/v1/instagrams/authorize';
const INSTAGRAM_APP_AUTHORIZE_URL = process.env.INSTAGRAM_APP_AUTHORIZE_URL || 'https://api.instagram.com/oauth/authorize';
const INSTAGRAM_LOGIN_REDIRECT_URL = process.env.INSTAGRAM_LOGIN_REDIRECT_URL || 'https://app.getkobe.com/instagrams/handleAuth';
const INSTAGRAM_CLIENT_ID = process.env.INSTAGRAM_CLIENT_ID || 498096319805223;
const kobeLogoDataURL = require('./logoDataURL').logo
const SUBMIT_CONTENT_GUIDE_EMAIL_TEMPLATE_ID = 'd-049ee2e8a44c417c8c1e04ea46416a88'
const CLIENT_FEEDBACK_FORM_URL = '/client/feedback-form'
const BRAND_SHEET_FORM_URL = '/client/brand-fact-sheet'
const RATE_CARD_FORM_URL = '/influencers/rate-card-form'
const JOIN_COMMUNITY_FORM_URL = '/influencers/join-community-form'
const PROFILE_TALLY_FORM_URL = '/creators/travel'
const SIGNING_IN_FORM_URL = '/influencers/signing-form'
const CREATER_CONCEPT_FORM_URL = '/creator/concept-form'
const gDriveConfig = {
  DEVELOPER_KEY: process.env.GDRIVE_DEVELOPER_KEY || 'AIzaSyBd1jDuvZ-ZvdxhuJ2VUMFPDmxfCAkhdhs',
  CLIENT_ID: process.env.GDRIVE_CLIENT_ID || '360808666245-rjo80hp2og0r2ev32mhjgb2ltd2uomff.apps.googleusercontent.com',
  SCOPE: process.env.GDRIVE_SCOPE || 'https://www.googleapis.com/auth/drive.readonly'
}
const cldConfig = {
  CLOUD_NAME: process.env.CLOUDINARY_SERVICE_CLOUD || 'kobeglobal',
  UPLOAD_PRESET: process.env.UPLOAD_PRESET || 'ml_default',
  API_KEY: process.env.API_KEY || '382334513349313'
}
const sendGridTemplateIds = {
  co_reject_influencer_for_campaign: 'd-a6a4eeae7e48417a920949fcdb36befe',
  co_approve_influencer_for_campaign: 'd-8be341275fe746e599e6bffb89ffe4ee'
}
const gSigninConfig = {
  CLIENT_ID: process.env.GDRIVE_CLIENT_ID || '360808666245-rjo80hp2og0r2ev32mhjgb2ltd2uomff.apps.googleusercontent.com'
}
const userRoles = {
  SUPER_ADMIN_HIGH: 0,
  SUPER_ADMIN_LOW: 1,
  COMPANY_ADMIN_HIGH: 2,
  COMPANY_ADMIN_LOW: 3,
  AD_STRATEGIST: 4,
  INFLUENCER: 5,
  CLIENT: 6,
  FINANCE: 7,
  ACCOUNT_MANAGER: 8,
  MARKETING: 9
}

const regexPattern = {
  email: /^([\w\D.-]+@([\w\D-]+)\.+\w{1,}$)/,
  password: /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,}$/,
  lowers: /(.*[a-z].*)/,
  uppers: /(.*[A-Z].*)/,
  numbers: /(.*[0-9].*)/,
  symbols: /(?=.*[^\w\d\s:])/,
  instagram: /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am)\/p\/([A-Za-z0-9-_]+)/g,
  instagram_reel: /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am)\/reel\/([A-Za-z0-9-_]+)/g,
  instagram_post: /\/p\/([^\/]+)[\/|?]/,
  TIKTOK_POST: /\/video\/([^\/]+[0-9])/,
  YOUTUBE_POST: /v=([^&#]{5,})/,
  instagram_profile: /(?:https?:\/\/)?(?:www\.)?instagram\.com\/([a-zA-Z0-9_]+)/,
  tiktok_profile: /@[\w]+/,
  instagram_tv: /\/tv\/([^\/]+)[\/|?]/,
  search_value: /{{2}[a-zA-Z0-9\s_]+}{2}/g,
  date_format: /^\d{2}\/\d{2}\/\d{4}$/
}

const campaignStatus = {
  DRAFT: 0,
  PENDING_CLIENT_APPROVAL: 1,
  PAIRING_BRIEF: 2,
  PAIRING_INFLUENCER: 3,
  RATE_CARD: 4,
  ONGOING: 5,
  REVIEW: 7,
  COMPLETE: 6
}

// const pairingStatus = {
//   NEW: 0,
//   ELIMINATION_PENDING: 1,
//   APPROVED: 2,
//   INVITED: 3,
//   ACCEPT: 4,
//   REJECT: 5,
//   INQUIRY: 6,
//   CO_REJECT: 7
// }

const pairingStatus = {
  NEW: 0,
  ELIMINATION_PENDING: 1,
  APPROVED: 2,
  INVITED: 3,
  INTERESTED: 4,
  NOT_INTERESTED: 5,
  ACCEPTED: 6,
  NOT_ACCEPTED: 7,
  INQUIRY: 8
}

const freeAccessRoutes = [
  'Login',
  'ClientLogin',
  'InstagramLogin',
  'ForgotPassword',
  'ResetPassword',
  'PrivateRegister',
  'Reports'
]

const postStatus = {
  AD_STRATEGIST_PENDING: 0,
  CLIENT_PENDING: 1,
  APPROVE: 2,
  LIVE: 3,
  COMPLETE: 4,
  ARCHIVE: 5
}

const accountDeleteStatus = {
  PENDING: 0,
  DELETED: 1
}

const dashboardTypes = {
  activation: 1,
  brief: 2,
  pairing: 3,
  drafts: 4,
  reporting: 5
}

const campaignStatusDisplay = {
  [campaignStatus.DRAFT]: {
    display: 'Draft',
    url: 'draft',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  [campaignStatus.PENDING_CLIENT_APPROVAL]: {
    display: 'Pending approval',
    url: 'pending_approval',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  [campaignStatus.PAIRING_BRIEF]: {
    display: 'Pairing Brief',
    url: 'pairing_brief',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  [campaignStatus.PAIRING_INFLUENCER]: {
    display: 'Pairing influencer',
    url: 'pairing_influencer',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  [campaignStatus.RATE_CARD]: {
    display: 'Rate Card',
    url: 'rate_card',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  [campaignStatus.ONGOING]: {
    display: 'On-going',
    url: 'on_going',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
      // userRoles.INFLUENCER
    ]
  },
  [campaignStatus.REVIEW]: {
    display: 'Review',
    url: 'review',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
      // userRoles.INFLUENCER
    ]
  },
  [campaignStatus.COMPLETE]: {
    display: 'Completed',
    url: 'completed',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  }
}

const postStatusDisplayExternal = {
  [postStatus.AD_STRATEGIST_PENDING]: {
    display: 'Submitted Posts',
    url: 'pending-kobe',
    permissions: [
      userRoles.INFLUENCER
    ]
  },
  [postStatus.CLIENT_PENDING]: {
    display: 'Pending Posts',
    url: 'pending-client',
    permissions: [
      userRoles.INFLUENCER
    ]
  },
  [postStatus.APPROVE]: {
    display: 'Approved Posts',
    url: 'approved',
    permissions: [
      userRoles.INFLUENCER
    ]
  },
  [postStatus.LIVE]: {
    display: 'Published Posts',
    url: 'published',
    permissions: [
      userRoles.INFLUENCER
    ]
  },
  [postStatus.COMPLETE]: {
    display: 'Completed Posts',
    url: 'completed',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER
    ]
  },
  [postStatus.ARCHIVE]: {
    display: 'Archived Posts',
    url: 'internal/archive',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER
    ]
  }
}
const postStatusDisplayInternal = {
  [postStatus.AD_STRATEGIST_PENDING]: {
    display: 'Submitted Posts',
    url: 'internal/pending-kobe',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  [postStatus.CLIENT_PENDING]: {
    display: 'Pending Posts',
    url: 'internal/pending-client',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  [postStatus.APPROVE]: {
    display: 'Approved Posts',
    url: 'internal/approved',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  [postStatus.LIVE]: {
    display: 'Published Posts',
    url: 'internal/published',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  [postStatus.COMPLETE]: {
    display: 'Completed Posts',
    url: 'internal/completed',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  [postStatus.ARCHIVE]: {
    display: 'Archived Posts',
    url: 'internal/archive',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER
    ]
  }
}

const userGenders = {
  MALE: 0,
  FEMALE: 1,
  NON_BINARY: 2
}

const userGenderDisplay = [{
  value: userGenders.MALE,
  text: 'Male'
},
{
  value: userGenders.FEMALE,
  text: 'Female'
},
{
  value: userGenders.NON_BINARY,
  text: 'Genderqueer/Non-Binary'
}
]
/*
  To change the layout by groups, splited into two type of Navigation Menu.
  singleNavMenu and groupNavMenu. Need to control by permissions to hide or show on the platform.
*/
const singleNavMenu = [
  {
    name: 'Dashboard',
    link: '/',
    icon: 'mdi-view-dashboard',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.CLIENT,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  {
    name: 'CC Dashboard',
    link: '/co/dashboard',
    icon: 'mdi-chart-tree',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH
    ]
  },
  {
    name: 'AM Dashboard',
    link: '/am/dashboard',
    icon: 'mdi-chart-timeline',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH
    ]
  },
  {
    name: 'Users',
    link: '/users',
    icon: 'mdi-account-group',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.ACCOUNT_MANAGER,
      userRoles.AD_STRATEGIST,
      userRoles.FINANCE
    ]
  },
  // {
  //   name: 'Influencer Delete Requests',
  //   link: '/influencer-delete-requests',
  //   icon: 'mdi-account-remove',
  //   permissions: [
  //     userRoles.SUPER_ADMIN_HIGH,
  //     userRoles.SUPER_ADMIN_LOW,
  //     userRoles.COMPANY_ADMIN_HIGH,
  //     userRoles.COMPANY_ADMIN_LOW
  //   ]
  // },
  {
    name: 'All companies',
    link: '/companies',
    icon: 'mdi-office-building',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW]
  },
  {
    name: 'Reports',
    icon: 'mdi-file-document',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ],
    subMenus: [
      {
        name: 'All Campaigns Report',
        link: '/campaigns/all',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'All Posts',
        link: '/posts/internal/all-posts',
        icon: 'mdi-file-chart',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'AOK Report',
        link: '/aok-report',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Status Report',
        link: '/posts/co-creating/status-report',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Draft Submissions Report',
        link: '/posts/draft-submissions-report',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Campaign COGS',
        link: '/campaigns/campaign-cogs',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Campaign Timeline Summary',
        link: '/campaigns/timeline/summary',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Stats Analysis',
        link: '/campaigns/statistics/analysis',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      }
    ]
  },
  {
    name: 'Search',
    icon: 'mdi-account-search',
    permissions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ],
    subMenus: [
      {
        name: 'Creators Search',
        link: '/creators/search',
        icon: 'mdi-account-search',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Creator Discovery',
        link: '/influencers/discovery',
        icon: 'mdi-account-search',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Content Search',
        link: '/content/search',
        icon: 'mdi-account-search',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'All Influencers',
        link: '/all-influencers',
        icon: 'mdi-account-group-outline',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          // userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE,
          userRoles.MARKETING
        ]
      },
      {
        name: 'Social Data',
        link: '/influencers/social-data',
        icon: 'mdi-at',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      }
    ]
  },
  {
    name: 'Profile',
    link: '/profile',
    icon: 'fa-user',
    permissions: [userRoles.INFLUENCER]
  },
  {
    name: 'Submit Draft Post',
    link: '/v2/submit-draft-post',
    icon: 'mdi-tooltip-edit',
    permissions: [userRoles.INFLUENCER]
  },
  {
    name: 'Submit Payout',
    link: '/submit-post-payout-creator',
    icon: 'mdi-account-cash',
    permissions: [userRoles.INFLUENCER]
  },
  {
    name: 'Content Storyboard',
    link: '/content-storyboard-list',
    icon: 'mdi-tooltip-edit',
    permissions: [userRoles.INFLUENCER]
  },
  {
    name: 'Campaigns',
    link: '/clients/campaigns',
    icon: 'mdi-account-group',
    permissions: [
      userRoles.CLIENT
    ]
  },
  {
    name: 'Content Storyboard',
    link: '/content-storyboard',
    icon: 'mdi-file-document',
    permissions: [
      userRoles.CLIENT
    ]
  },
  {
    name: 'Posts',
    link: '/clients/posts',
    icon: 'mdi-file-document',
    permissions: [
      userRoles.CLIENT
    ]
  },
  // {
  //   name: 'Post Calendar',
  //   link: '/clients/posts-approved-calender',
  //   icon: 'mdi-calendar-check',
  //   permissions: [
  //     userRoles.CLIENT
  //   ]
  // },
  {
    name: 'Campaign Reports',
    link: '/clients/campaigns-reports',
    icon: 'mdi-file-chart-outline',
    permissions: [userRoles.CLIENT]
  }
  // Disable the Audience Insights for Influencers upon Request
  // {
  //   name: 'My Audience Insights',
  //   link: '/my-audience-insights',
  //   icon: 'mdi-chart-areaspline',
  //   permissions: [userRoles.INFLUENCER]
  // }
]

const groupNavMenu = [
  {
    name: 'Activating',
    icon: 'mdi-routes',
    subMenus: [
      // {
      //   name: 'Vendor Creation Form',
      //   link: '/client/vendor-creation-form',
      //   icon: 'mdi-handshake',
      //   permissions: [
      //     userRoles.CLIENT
      //   ]
      // },
      {
        name: 'Clients',
        link: '/clients',
        icon: 'mdi-domain',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Draft Campaigns',
        link: '/campaigns/' + campaignStatusDisplay[campaignStatus.DRAFT]['url'],
        icon: 'mdi-file-document-edit',
        permissions: campaignStatusDisplay[campaignStatus.DRAFT]['permissions']
      },
      {
        name: 'Pending Campaigns',
        link: '/campaigns/' + campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['url'],
        icon: 'mdi-file-clock',
        permissions: campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['permissions']
      },
      {
        name: 'Brand Fact Sheet',
        link: '/client/brand-fact-sheet',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.ACCOUNT_MANAGER,
          userRoles.AD_STRATEGIST
        ]
      },
      {
        name: 'Campaign Timeline',
        link: '/campaigns/timeline',
        icon: 'mdi-chart-timeline',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.ACCOUNT_MANAGER,
          userRoles.AD_STRATEGIST
        ]
      }
    ]
  },
  {
    name: 'Pairing',
    icon: 'mdi-account-multiple-check',
    subMenus: [
      {
        name: 'Pairing Campaigns',
        link: '/campaigns/' + campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['url'],
        icon: 'mdi-account-switch',
        permissions: campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['permissions']
      },
      {
        name: 'Invoices & Brief Confirmation',
        link: '/influencers/invoices-brief-confirmation',
        icon: 'mdi-account-multiple-check',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.FINANCE,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER
        ]
      },
      {
        name: 'Content Storyboard',
        link: '/content-storyboard',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE,
          userRoles.CLIENT
        ]
      },
      // {
      //   name: 'Paired Creators',
      //   link: '/paired/creators',
      //   icon: 'mdi-account-switch',
      //   permissions: [
      //     userRoles.SUPER_ADMIN_HIGH,
      //     userRoles.SUPER_ADMIN_LOW,
      //     userRoles.COMPANY_ADMIN_HIGH,
      //     userRoles.COMPANY_ADMIN_LOW,
      //     userRoles.AD_STRATEGIST,
      //     userRoles.ACCOUNT_MANAGER,
      //     userRoles.FINANCE
      //   ]
      // },
      {
        name: 'IMS Influencers',
        link: '/influencers',
        icon: 'mdi-account-multiple',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          // userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Invite to IMS',
        link: '/users/create-link',
        icon: 'mdi-account-plus',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Ratecard Forms',
        link: '/influencers/rate-cards',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE,
          userRoles.MARKETING
        ]
      },
      {
        name: 'Creator Community Forms',
        link: '/influencers/join-community',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE,
          userRoles.MARKETING
        ]
      }
    ]
  },
  {
    name: 'Co-Creating',
    icon: 'mdi-sync',
    subMenus: [
      {
        name: 'Ongoing Campaigns',
        link: '/campaigns/' + campaignStatusDisplay[campaignStatus.ONGOING]['url'],
        icon: 'mdi-file-check',
        permissions: campaignStatusDisplay[campaignStatus.ONGOING]['permissions']
      },
      // {
      //   name: 'Invited Campaigns',
      //   link: '/campaigns/invited',
      //   icon: 'mdi-account-multiple-plus',
      //   permissions: [userRoles.INFLUENCER]
      // },
      {
        name: postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['display'],
        link: '/posts/' + postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['url'],
        icon: 'mdi-file-clock-outline',
        permissions: postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['permissions']
      },
      {
        name: postStatusDisplayInternal[postStatus.CLIENT_PENDING]['display'],
        link: '/posts/' + postStatusDisplayInternal[postStatus.CLIENT_PENDING]['url'],
        icon: 'mdi-file-sync',
        permissions: postStatusDisplayInternal[postStatus.CLIENT_PENDING]['permissions']
      },
      {
        name: postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['display'],
        link: '/posts/' + postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['url'],
        icon: 'mdi-file-clock-outline',
        permissions: postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['permissions']
      },
      {
        name: postStatusDisplayExternal[postStatus.CLIENT_PENDING]['display'],
        link: '/posts/' + postStatusDisplayExternal[postStatus.CLIENT_PENDING]['url'],
        icon: 'mdi-file-sync',
        permissions: postStatusDisplayExternal[postStatus.CLIENT_PENDING]['permissions']
      }
    ]
  },
  {
    name: 'Review',
    icon: 'mdi-eye-check-outline',
    subMenus: [
      {
        name: 'Review Campaigns',
        link: '/campaigns/' + campaignStatusDisplay[campaignStatus.REVIEW]['url'],
        icon: 'mdi-file-check',
        permissions: campaignStatusDisplay[campaignStatus.REVIEW]['permissions']
      },
      {
        name: 'Creator Stats & Rating',
        link: '/campaignPayoutsInternal',
        icon: 'mdi-account-cash',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Campaign Reports Internal',
        link: '/campaign-report-internal',
        icon: 'mdi-file-chart',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Upcoming Review Meetings',
        link: '/campaigns/upcoming-review-meetings',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Stats Collection Calendar',
        link: '/stats-collection-calendar',
        icon: 'mdi-calendar-check',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.CLIENT,
          userRoles.FINANCE
        ]
      }
    ]
  },
  {
    name: 'Complete',
    icon: 'mdi-check',
    subMenus: [
      {
        name: postStatusDisplayExternal[postStatus.APPROVE]['display'],
        link: '/posts/' + postStatusDisplayExternal[postStatus.APPROVE]['url'],
        icon: 'mdi-file-document-box-check',
        permissions: postStatusDisplayExternal[postStatus.APPROVE]['permissions']
      },
      {
        name: postStatusDisplayInternal[postStatus.APPROVE]['display'],
        link: '/posts/' + postStatusDisplayInternal[postStatus.APPROVE]['url'],
        icon: 'mdi-file-document-box-check',
        permissions: postStatusDisplayInternal[postStatus.APPROVE]['permissions']
      },
      {
        name: postStatusDisplayInternal[postStatus.LIVE]['display'],
        link: '/posts/' + postStatusDisplayInternal[postStatus.LIVE]['url'],
        icon: 'mdi-file-link',
        permissions: postStatusDisplayInternal[postStatus.LIVE]['permissions']
      },
      {
        name: postStatusDisplayExternal[postStatus.LIVE]['display'],
        link: '/posts/' + postStatusDisplayExternal[postStatus.LIVE]['url'],
        icon: 'mdi-file-link',
        permissions: postStatusDisplayExternal[postStatus.LIVE]['permissions']
      },
      // {
      //   name: 'Creator Stats & Rating',
      //   link: '/campaignPayoutsInternal',
      //   icon: 'mdi-account-cash',
      //   permissions: [
      //     userRoles.SUPER_ADMIN_HIGH,
      //     userRoles.SUPER_ADMIN_LOW,
      //     userRoles.COMPANY_ADMIN_HIGH,
      //     userRoles.AD_STRATEGIST,
      //     userRoles.ACCOUNT_MANAGER,
      //     userRoles.FINANCE
      //   ]
      // },
      // {
      //   name: 'Payouts Report',
      //   link: '/payouts-report',
      //   icon: 'mdi-file-document',
      //   permissions: [
      //     userRoles.SUPER_ADMIN_HIGH,
      //     userRoles.SUPER_ADMIN_LOW,
      //     userRoles.COMPANY_ADMIN_HIGH
      //   ]
      // },
      // {
      //   name: 'Payouts Report',
      //   link: '/influencer-payouts-report',
      //   icon: 'mdi-file-document',
      //   permissions: [
      //     userRoles.INFLUENCER
      //   ]
      // },
      // {
      //   name: 'Campaign Reports Internal',
      //   link: '/campaign-report-internal',
      //   icon: 'mdi-file-chart',
      //   permissions: [
      //     userRoles.SUPER_ADMIN_HIGH,
      //     userRoles.SUPER_ADMIN_LOW,
      //     userRoles.COMPANY_ADMIN_HIGH,
      //     userRoles.COMPANY_ADMIN_LOW,
      //     userRoles.AD_STRATEGIST,
      //     userRoles.ACCOUNT_MANAGER,
      //     userRoles.FINANCE
      //   ]
      // },
      // {
      //   name: 'Upcoming Review Meetings',
      //   link: '/campaigns/upcoming-review-meetings',
      //   icon: 'mdi-file-document',
      //   permissions: [
      //     userRoles.SUPER_ADMIN_HIGH,
      //     userRoles.SUPER_ADMIN_LOW,
      //     userRoles.COMPANY_ADMIN_HIGH,
      //     userRoles.COMPANY_ADMIN_LOW,
      //     userRoles.AD_STRATEGIST,
      //     userRoles.ACCOUNT_MANAGER,
      //     userRoles.FINANCE
      //   ]
      // },
      {
        name: 'Campaign Reports',
        link: '/campaigns/reports',
        icon: 'mdi-file-chart-outline',
        permissions: [userRoles.CLIENT]
      },
      // {
      //   name: 'Campaign Overview',
      //   link: '/campaigns/overview',
      //   icon: 'mdi-file-chart-outline',
      //   permissions: [
      //     userRoles.SUPER_ADMIN_HIGH,
      //     userRoles.SUPER_ADMIN_LOW,
      //     userRoles.COMPANY_ADMIN_HIGH,
      //     userRoles.AD_STRATEGIST,
      //     userRoles.ACCOUNT_MANAGER,
      //     userRoles.FINANCE]
      // },
      {
        name: 'Client Feedbacks',
        link: '/client/feedback-form',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.ACCOUNT_MANAGER,
          userRoles.AD_STRATEGIST,
          userRoles.FINANCE
        ]
      },
      {
        name: postStatusDisplayInternal[postStatus.COMPLETE]['display'],
        link: '/posts/' + postStatusDisplayInternal[postStatus.COMPLETE]['url'],
        icon: 'mdi-zip-box',
        permissions: postStatusDisplayInternal[postStatus.COMPLETE]['permissions']
      },
      {
        name: 'Finished Campaigns',
        link: '/campaigns/' + campaignStatusDisplay[campaignStatus.COMPLETE]['url'],
        icon: 'mdi-zip-box-outline',
        permissions: campaignStatusDisplay[campaignStatus.COMPLETE]['permissions']
      }
    ]
  },
  {
    name: 'Financial',
    icon: 'mdi-finance',
    subMenus: [
      // {
      //   name: 'Revenue Recognize',
      //   link: '/finance/revenue-recognize',
      //   icon: 'mdi-cash-usd',
      //   permissions: [
      //     userRoles.SUPER_ADMIN_HIGH,
      //     userRoles.SUPER_ADMIN_LOW,
      //     userRoles.ACCOUNT_MANAGER,
      //     userRoles.FINANCE
      //   ]
      // },
      // {
      //   name: 'Payment Recognize',
      //   link: '/finance/money-in',
      //   icon: 'mdi-cash-usd',
      //   permissions: [
      //     userRoles.SUPER_ADMIN_HIGH,
      //     userRoles.SUPER_ADMIN_LOW,
      //     userRoles.ACCOUNT_MANAGER,
      //     userRoles.FINANCE
      //   ]
      // },
      // {
      //   name: 'Payout Recognize',
      //   link: '/finance/money-out',
      //   icon: 'mdi-cash-usd',
      //   permissions: [
      //     userRoles.SUPER_ADMIN_HIGH,
      //     userRoles.SUPER_ADMIN_LOW,
      //     userRoles.AD_STRATEGIST,
      //     userRoles.FINANCE
      //   ]
      // },
      {
        name: 'Payment Consolidation',
        link: '/finance/payment-consolidation',
        icon: 'mdi-cash-usd',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Payment Status',
        link: '/finance/payment-consolidation/status',
        icon: 'mdi-cash-usd',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'COGS Estimation',
        link: '/finance/cogs-estimation',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.ACCOUNT_MANAGER,
          userRoles.AD_STRATEGIST,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Profit Summary',
        link: '/finance/profit-summary',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Masterlist',
        link: '/finance/masterlist',
        icon: 'mdi-file-document',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      }
      // {
      //   name: 'Accrued COGS',
      //   link: '/finance/accrued-cogs',
      //   icon: 'mdi-file-document',
      //   permissions: [
      //     userRoles.SUPER_ADMIN_HIGH,
      //     userRoles.SUPER_ADMIN_LOW,
      //     userRoles.COMPANY_ADMIN_HIGH,
      //     userRoles.COMPANY_ADMIN_LOW,
      //     userRoles.AD_STRATEGIST,
      //     userRoles.ACCOUNT_MANAGER,
      //     userRoles.FINANCE
      //   ]
      // }
    ]
  },
  {
    name: 'Services',
    icon: 'mdi-hammer-screwdriver',
    subMenus: [
      {
        name: 'Content Analysis',
        link: '/content-analysis',
        icon: 'mdi-layers-search',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Influencer Lists',
        link: '/services/influencer-lists',
        icon: 'mdi-cloud-search',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      }
    ]
  },
  {
    name: 'Archived',
    icon: 'mdi-archive',
    subMenus: [
      {
        name: 'Archived Campaigns',
        link: '/campaigns/archive',
        icon: 'mdi-archive',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: postStatusDisplayInternal[postStatus.ARCHIVE]['display'],
        link: '/posts/' + postStatusDisplayInternal[postStatus.ARCHIVE]['url'],
        icon: 'mdi-archive',
        permissions: postStatusDisplayInternal[postStatus.ARCHIVE]['permissions']
      },
      {
        name: 'Archived Payment Cons..',
        link: '/finance/payment-consolidation/archive',
        icon: 'mdi-archive',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      },
      {
        name: 'Archived Client Feedback..',
        link: '/client/feedback-form/archive/lists',
        icon: 'mdi-archive',
        permissions: [
          userRoles.SUPER_ADMIN_HIGH,
          userRoles.SUPER_ADMIN_LOW,
          userRoles.COMPANY_ADMIN_HIGH,
          userRoles.COMPANY_ADMIN_LOW,
          userRoles.AD_STRATEGIST,
          userRoles.ACCOUNT_MANAGER,
          userRoles.FINANCE
        ]
      }
    ]
  }
]

const userPermissions = {
  user: {
    create: {
      [userRoles.SUPER_ADMIN_HIGH]: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.INFLUENCER,
        userRoles.FINANCE,
        userRoles.MARKETING
      ],
      [userRoles.SUPER_ADMIN_LOW]: [
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.INFLUENCER,
        userRoles.FINANCE,
        userRoles.MARKETING
      ],
      [userRoles.COMPANY_ADMIN_HIGH]: [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.FINANCE],
      [userRoles.COMPANY_ADMIN_LOW]: [userRoles.AD_STRATEGIST, userRoles.FINANCE],
      [userRoles.ACCOUNT_MANAGER]: [userRoles.AD_STRATEGIST],
      [userRoles.AD_STRATEGIST]: [userRoles.AD_STRATEGIST, userRoles.INFLUENCER],
      [userRoles.FINANCE]: [userRoles.AD_STRATEGIST, userRoles.FINANCE]
    },
    update: {
      [userRoles.SUPER_ADMIN_HIGH]: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.INFLUENCER,
        userRoles.FINANCE,
        userRoles.MARKETING
      ],
      [userRoles.SUPER_ADMIN_LOW]: [
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.INFLUENCER,
        userRoles.FINANCE,
        userRoles.MARKETING
      ],
      [userRoles.COMPANY_ADMIN_HIGH]: [userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.FINANCE],
      [userRoles.COMPANY_ADMIN_LOW]: [userRoles.AD_STRATEGIST, userRoles.FINANCE],
      [userRoles.ACCOUNT_MANAGER]: [userRoles.AD_STRATEGIST],
      [userRoles.FINANCE]: [userRoles.AD_STRATEGIST, userRoles.FINANCE]
    },
    delete: {
      [userRoles.SUPER_ADMIN_HIGH]: [
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.INFLUENCER,
        userRoles.FINANCE,
        userRoles.MARKETING
      ],
      [userRoles.SUPER_ADMIN_LOW]: [
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.INFLUENCER,
        userRoles.FINANCE,
        userRoles.MARKETING
      ],
      [userRoles.COMPANY_ADMIN_HIGH]: [userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.FINANCE],
      [userRoles.COMPANY_ADMIN_LOW]: [userRoles.AD_STRATEGIST, userRoles.FINANCE],
      [userRoles.ACCOUNT_MANAGER]: [userRoles.AD_STRATEGIST],
      [userRoles.FINANCE]: [userRoles.AD_STRATEGIST, userRoles.FINANCE]
    },
    view: {
      [userRoles.SUPER_ADMIN_HIGH]: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.INFLUENCER,
        userRoles.FINANCE,
        userRoles.MARKETING
      ],
      [userRoles.SUPER_ADMIN_LOW]: [
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.INFLUENCER,
        userRoles.FINANCE,
        userRoles.MARKETING
      ],
      [userRoles.COMPANY_ADMIN_HIGH]: [userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.FINANCE],
      [userRoles.COMPANY_ADMIN_LOW]: [userRoles.AD_STRATEGIST, userRoles.FINANCE],
      [userRoles.ACCOUNT_MANAGER]: [userRoles.AD_STRATEGIST],
      [userRoles.FINANCE]: [
        userRoles.FINANCE,
        userRoles.CLIENT,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.COMPANY_ADMIN_LOW
      ]
    },
    assignClient: {
      [userRoles.SUPER_ADMIN_HIGH]: [userRoles.AD_STRATEGIST],
      [userRoles.SUPER_ADMIN_LOW]: [userRoles.AD_STRATEGIST],
      [userRoles.COMPANY_ADMIN_HIGH]: [userRoles.AD_STRATEGIST],
      [userRoles.COMPANY_ADMIN_LOW]: [userRoles.AD_STRATEGIST],
      [userRoles.FINANCE]: [userRoles.AD_STRATEGIST],
      [userRoles.ACCOUNT_MANAGER]: [userRoles.AD_STRATEGIST]
    },
    confirmUser: {
      [userRoles.SUPER_ADMIN_HIGH]: [userRoles.INFLUENCER],
      [userRoles.SUPER_ADMIN_LOW]: [userRoles.INFLUENCER],
      [userRoles.ACCOUNT_MANAGER]: [userRoles.INFLUENCER],
      [userRoles.FINANCE]: [userRoles.INFLUENCER]
    }
  },
  client: {
    create: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ],
    view: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ],
    edit: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ],
    delete: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW
    ],
    updateUser: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ]
  },
  influencer: {
    create: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER
    ],
    view: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ],
    edit: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW
    ],
    delete: [],
    assignCompany: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW]
  },
  campaign: {
    create: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ],
    view: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.INFLUENCER,
      userRoles.FINANCE
    ],
    viewByClient: [
      userRoles.CLIENT
    ],
    edit: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ],
    settings: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ],
    activate: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH
      ],
      campaignStatus: [
        campaignStatus.PENDING_CLIENT_APPROVAL,
        campaignStatus.PAIRING_INFLUENCER,
        campaignStatus.COMPLETE
      ]
    },
    directClient: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH
      ],
      campaignStatus: [
        campaignStatus.DRAFT
      ]
    },
    delete: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ],
      campaignStatus: [campaignStatus.DRAFT]
    },
    draftSubmit: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ],
      campaignStatus: [campaignStatus.DRAFT]
    },
    pairingBrief: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH
        // Hide the unfinish button
        // userRoles.SUPER_ADMIN_LOW,
        // userRoles.COMPANY_ADMIN_HIGH,
        // userRoles.AD_STRATEGIST
      ],
      campaignStatus: [campaignStatus.PAIRING_BRIEF]
    },
    releaseToAdmin: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.AD_STRATEGIST
      ],
      campaignStatus: [campaignStatus.PENDING_CLIENT_APPROVAL]
    },
    clientApprove: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.CLIENT
      ],
      campaignStatus: [campaignStatus.PENDING_CLIENT_APPROVAL]
    },
    startCampaign: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER
      ],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER]
    },
    reviewCampaign: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ],
      campaignStatus: [campaignStatus.ONGOING]
    },
    closeCampaign: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ],
      campaignStatus: [campaignStatus.REVIEW]
    },
    viewBrandFactSheet: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ],
      campaignStatus: [campaignStatus.DRAFT]
    },
    viewPayout: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    },
    viewPairing: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER, campaignStatus.ONGOING, campaignStatus.REVIEW, campaignStatus.PENDING_CLIENT_APPROVAL]
    },
    eliminating: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.CLIENT
      ],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER]
    },
    influencerAccept: {
      userRoles: [userRoles.INFLUENCER],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER]
    },
    influencerReject: {
      userRoles: [userRoles.INFLUENCER],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER]
    },
    viewPost: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH
        // userRoles.SUPER_ADMIN_LOW,
        // userRoles.COMPANY_ADMIN_HIGH,
        // userRoles.COMPANY_ADMIN_LOW,
        // userRoles.AD_STRATEGIST,
        // userRoles.CLIENT,
        // userRoles.INFLUENCER
      ],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER, campaignStatus.ONGOING]
    },
    viewInfluencers: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.CLIENT,
        userRoles.FINANCE
      ],
      campaignStatus: [campaignStatus.ONGOING, campaignStatus.COMPLETE]
    },
    clientFeedback: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.ACCOUNT_MANAGER,
      userRoles.AD_STRATEGIST,
      userRoles.FINANCE
    ],
    editPayout: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.ACCOUNT_MANAGER,
      userRoles.AD_STRATEGIST
    ]
  },
  post: {
    create: [userRoles.INFLUENCER],
    view: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.CLIENT,
      userRoles.INFLUENCER,
      userRoles.FINANCE
    ],
    edit: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.INFLUENCER
      ],
      postStatus: [postStatus.AD_STRATEGIST_PENDING, postStatus.CLIENT_PENDING, postStatus.APPROVE]
    },
    editLiveDate: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER
      ],
      postStatus: [postStatus.AD_STRATEGIST_PENDING, postStatus.CLIENT_PENDING, postStatus.APPROVE]
    },
    delete: [],
    assignCampaign: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ],
      postStatus: [postStatus.AD_STRATEGIST_PENDING]
    },
    mapInfluencer: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ],
      postStatus: [postStatus.AD_STRATEGIST_PENDING, postStatus.CLIENT_PENDING]
    },
    csApprove: {
      userRoles: [userRoles.AD_STRATEGIST],
      postStatus: [postStatus.AD_STRATEGIST_PENDING]
    },
    saleApprove: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ],
      postStatus: [postStatus.AD_STRATEGIST_PENDING]
    },
    directRelease: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST
      ],
      postStatus: [postStatus.AD_STRATEGIST_PENDING]
    },
    clientReview: {
      userRoles: [userRoles.CLIENT],
      postStatus: [postStatus.CLIENT_PENDING]
    },
    clientApproveDate: {
      userRoles: [userRoles.CLIENT],
      postStatus: [postStatus.APPROVE]
    },
    submitPostPayout: {
      userRoles: [
        userRoles.INFLUENCER
      ],
      postStatus: [postStatus.APPROVE, postStatus.LIVE]
    },
    enterPostURL: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ],
      postStatus: [postStatus.APPROVE]
    },
    markAsMetadataTagged: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW
      ],
      postStatus: [
        postStatus.AD_STRATEGIST_PENDING,
        postStatus.CLIENT_PENDING,
        postStatus.APPROVE,
        postStatus.LIVE
      ]
    },
    markAsComplete: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ],
      postStatus: [postStatus.LIVE]
    },
    markAsAbuseResolved: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST
      ],
      postStatus: [postStatus.CLIENT_PENDING]
    },
    releaseAbuseResolved: {
      userRoles: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER
      ],
      postStatus: [postStatus.CLIENT_PENDING]
    },
    changePostStatus: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.FINANCE
    ],
    influencerResubmit: [userRoles.INFLUENCER],
    clientApprove: [
      userRoles.CLIENT,
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER
    ],
    influencerLive: [userRoles.INFLUENCER]
  },
  dashboard: {
    servicesHealth: [
      userRoles.SUPER_ADMIN_HIGH
    ],
    xero: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.FINANCE
    ],
    kobeOverview: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ],
    postsSummary: [
      userRoles.INFLUENCER
    ],
    campaignSummary: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.COMPANY_ADMIN_HIGH,
      userRoles.COMPANY_ADMIN_LOW,
      userRoles.AD_STRATEGIST,
      userRoles.ACCOUNT_MANAGER,
      userRoles.FINANCE
    ],
    influencerTasks: [
      userRoles.INFLUENCER
    ],
    csTasks: [
      userRoles.AD_STRATEGIST
    ],
    saleTasks: [
      userRoles.COMPANY_ADMIN_LOW
    ],
    clientTasks: [
      userRoles.CLIENT
    ],
    audienceInsightPreview: [
      userRoles.INFLUENCER
    ]
  },
  financial: {
    create: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.FINANCE
    ],
    import: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.FINANCE
    ],
    actions: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.FINANCE
    ]
  }
}

const userRolesDetails = {
  [userRoles.SUPER_ADMIN_HIGH]: {
    display: 'Super Admin',
    url: 'super_admins',
    icon: 'user-secret'
  },
  [userRoles.SUPER_ADMIN_LOW]: {
    display: 'Admin',
    url: 'admins',
    icon: 'user-secret'
  },
  [userRoles.COMPANY_ADMIN_HIGH]: {
    display: 'Account Admin',
    url: 'company_super_admins',
    icon: 'user-md'
  },
  // Sales Team will use this role
  [userRoles.COMPANY_ADMIN_LOW]: {
    display: 'Sales',
    url: 'sales',
    icon: 'user-md'
  },
  [userRoles.AD_STRATEGIST]: {
    display: 'Content Curator (CC)',
    url: 'ad_strategists',
    icon: 'user'
  },
  [userRoles.ACCOUNT_MANAGER]: {
    display: 'Account Manager (AM)',
    url: 'account_manager',
    icon: 'user'
  },
  [userRoles.INFLUENCER]: {
    display: 'Influencer',
    url: 'influencers',
    icon: 'male'
  },
  [userRoles.CLIENT]: {
    display: 'Client',
    url: 'clients',
    icon: 'male'
  },
  [userRoles.FINANCE]: {
    display: 'Finance',
    url: 'finances',
    icon: 'female'
  },
  [userRoles.MARKETING]: {
    display: 'Marketing',
    url: 'marketing',
    icon: 'male'
  }
}

const socialMediaPlatforms = [{
  icon: '/static/img/f_logo_RGB-Blue_72.png',
  label: 'Facebook',
  placeholder: 'https://www.facebook.com/yourAccount',
  value: ''
},
{
  icon: '/static/img/youtube_social_icon_white.png',
  label: 'Youtube',
  placeholder: 'https://www.youtube.com/channel/abcedfghijklmn',
  value: ''
},
{
  icon: '/static/img/tiktok.svg',
  label: 'Tiktok',
  placeholder: 'ID: 1234567890',
  value: ''
},
{
  icon: '/static/img/x-logo.svg',
  label: 'X (Twitter)',
  placeholder: '@yourxhandle',
  value: ''
},
{
  icon: '/static/img/Tumblr_Logos_2018.03.06_Android Icon Blue.png',
  label: 'Tumblr',
  placeholder: 'https://yourAccount.tumblr.com/',
  value: ''
},
{
  icon: '/static/img/www_blog.png',
  label: 'Blog',
  placeholder: 'https://yourWebsite.com/',
  value: ''
}]

const apiServiceBaseURL = {
  campaign: '/api/v1/campaigns',
  pairing: '/api/v1/pairings',
  pairingOpen: '/api/v1/pairings-open',
  payment: '/api/v1/payments',
  post: '/api/v1/posts',
  influencer: '/api/v1/influencers'
}

const currencies = [
  'SGD',
  'USD',
  'MYR',
  'IDR',
  'VND',
  'PHP',
  'THB',
  'AUD',
  'NZD',
  'JPY'
]

const currencySymbols = [
  {
    'title': 'SGD',
    'symbol': 'S$'
  },
  {
    'title': 'USD',
    'symbol': 'US$'
  },
  {
    'title': 'MYR',
    'symbol': 'RM'
  },
  {
    'title': 'IDR',
    'symbol': 'Rp'
  },
  {
    'title': 'VND',
    'symbol': '₫'
  },
  {
    'title': 'PHP',
    'symbol': '₱'
  },
  {
    'title': 'THB',
    'symbol': '฿'
  },
  {
    'title': 'AUD',
    'symbol': 'AU$'
  },
  {
    'title': 'NZD',
    'symbol': 'NZ$'
  },
  {
    'title': 'JPY',
    'symbol': '¥'
  }
]

// const serverHost = process.env.SERVER_HOSTNAME || 'localhost'
// const serverPort = process.env.SERVER_PORT || '8081'

export default Object.assign({}, {
  FACEBOOK_APP_ID,
  PERMISSION_SCOPE,
  INSTAGRAM_AUTHORIZE_URL,
  INSTAGRAM_BASIC_AUTHORIZE_URL,
  INSTAGRAM_APP_AUTHORIZE_URL,
  INSTAGRAM_CLIENT_ID,
  INSTAGRAM_LOGIN_REDIRECT_URL,
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  userRoles,
  userRolesDetails,
  userPermissions,
  campaignStatus,
  campaignStatusDisplay,
  postStatus,
  accountDeleteStatus,
  postStatusDisplayExternal,
  postStatusDisplayInternal,
  singleNavMenu,
  groupNavMenu,
  userGenders,
  regexPattern,
  userGenderDisplay,
  freeAccessRoutes,
  socialMediaPlatforms,
  kobeLogoDataURL,
  pairingStatus,
  SUBMIT_CONTENT_GUIDE_EMAIL_TEMPLATE_ID,
  CLIENT_FEEDBACK_FORM_URL,
  BRAND_SHEET_FORM_URL,
  RATE_CARD_FORM_URL,
  JOIN_COMMUNITY_FORM_URL,
  PROFILE_TALLY_FORM_URL,
  SIGNING_IN_FORM_URL,
  CREATER_CONCEPT_FORM_URL,
  gDriveConfig,
  gSigninConfig,
  cldConfig,
  sendGridTemplateIds,
  apiServiceBaseURL,
  dashboardTypes,
  currencies,
  currencySymbols,
})



// WEBPACK FOOTER //
// ./src/config/index.js